import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

interface ActivatingStepProps {
  resellerName?: string;
  resellerLogoUrl?: string;
}

const ActivatingStep: React.FC<ActivatingStepProps> = ({
  resellerName,
  resellerLogoUrl
}) => {
  return (
    <div className="activation-step">

      <div className="activation-step__content">
        <div className="activation-loading">
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
            size="large"
          />
          <h2 className="activation-step__title">Activating Your Subscription</h2>
          <p className="activation-step__subtitle">
            Please wait while we set up your TruHu subscription...
          </p>
        </div>
      </div>
    </div>
  );
};

export default ActivatingStep;
